const REFERRAL_CODE_KEY = 'referral-code'

/** 进站推广码：登录/注册请求附带 referral_code，后端仅对新账号绑定，失效一律忽略 */
export function getReferralCode(): string {
  if (!import.meta.client) return ''
  return localStorage.getItem(REFERRAL_CODE_KEY) ?? ''
}

export function setReferralCode(code: string) {
  if (!import.meta.client) return
  localStorage.setItem(REFERRAL_CODE_KEY, code)
}

export function clearReferralCode() {
  if (!import.meta.client) return
  localStorage.removeItem(REFERRAL_CODE_KEY)
}
